import mainRoutePaths from '../../../router/portal/paths';

/**
 * Funkcja zwraca adres domyślnej strony głównej dla danego portalu.
 *
 * @param {Immutable.Map} globalSettings - obiekt ustawień globalnych.
 */

const getHomePageUrl = globalSettings => {
  const isDistrictsListAsHomePage = globalSettings.get(
    'home_page_is_districts_list'
  );

  const homePageLink = globalSettings.get('home_page_link');

  if (isDistrictsListAsHomePage) {
    return mainRoutePaths.districtList;
  }

  return homePageLink || mainRoutePaths.homePage;
};

export default getHomePageUrl;
